import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var LIGHT_THEME = {
  name: "light",
  dark: false,
  colors: {
    branding: {
      primary: "#69c028",
      "primary:hover": "#84d249",
      "primary:10": "#e9f6df",
      "primary-variant": "#006838",
      secondary: "#869097",
      "secondary:hover": "#a8afb4",
      "secondary:10": "#f7f9fa",
      "secondary-variant": "#203a9a",
      "secondary-variant:hover": "#344fb3",
      "secondary-variant:10": "#cbd4f6"
    },
    background: {
      primary: "#f7f9fa",
      "primary:lighten": "#ffffff",
      "primary:darken": "#ebeef0",
      secondary: "#2a3540",
      "secondary:lighten": "#52667a",
      "secondary:darken": "#000000",
      "overlay:90": "rgba(42, 53, 64, 0.9)",
      "overlay:50": "rgba(42, 53, 64, 0.5)",
      "overlay:25": "rgba(42, 53, 64, 0.25)",
      light: "#ffffff",
      dark: "#2a3540"
    },
    text: {
      primary: "#52667a",
      secondary: "#869097",
      tertiary: "#b8bfc3",
      reverse: "#ffffff",
      light: "#ffffff",
      dark: "#52667a"
    },
    webtitle: {
      primary: "#2a3540",
      secondary: "#869097",
      tertiary: "#b8bfc3",
      reverse: "#ffffff",
      light: "#ffffff",
      dark: "#52667a"
    },
    action: {
      success: "#69c028",
      "success:hover": "#90e254",
      "success:10": "#e9f6df",
      danger: "#f96565",
      "danger:hover": "#ff8181",
      "danger:10": "#fee8e8",
      warning: "#ffbb00",
      "warning:hover": "#ffcf4a",
      "warning:10": "#fff6dc",
      info: "#2eabc3",
      "info:hover": "#41bcd3",
      "info:10": "#ebfcff",
      soft: "#ebeef0",
      "soft:hover": "#c9d0d6",
      reverse: "#ffffff",
      "reverse:hover": "#ebeef0",
      light: "#ffffff",
      "light:hover": "#ebeef0",
      dark: "#52667a",
      "dark:hover": "#2a3540"
    },
    border: {
      primary: "#c9d0d6",
      reverse: "#52667a"
    },
    weather: {
      rainfall: "#2eabc3",
      temperature: "#ffbb00",
      "temperature-cold": "#cbf0ff",
      hygrometry: "#4e45c0",
      wind: "#c9d0d6",
      "wind-gust": "#869097",
      wetness: "#2eabc3",
      light: "#ffffff",
      dark: "#2a3540"
    },
    social: {
      owner: "#69c028",
      "owner-variant": "#45920b",
      guest: "#2eabc3",
      "guest-variant": "#2a85a3",
      network: "#ffbb00",
      position: "#f96565",
      disable: "#b8bfc3"
    },
    global: {
      green: "#69c028",
      "green:hover": "#90e254",
      "green:10": "#e9f6df",
      red: "#f96565",
      "red:hover": "#ff8181",
      "red:10": "#fee8e8",
      yellow: "#ffbb00",
      "yellow:hover": "#ffcf4a",
      "yellow:10": "#fff6dc",
      blue: "#2eabc3",
      "blue:hover": "#41bcd3",
      "blue:10": "#ebfcff",
      purple: "#4e45c0",
      "purple:hover": "#6359d6",
      "purple:10": "#f4eafb",
      orange: "#ff9000",
      "orange:hover": "#fca432",
      "orange:10": "#ffeedc"
    }
  }
}; // name: light

var DARK_THEME = {
  name: "dark",
  dark: true,
  colors: {
    branding: {
      primary: "#7ac542",
      "primary:hover": "#90e254",
      "primary:10": "#334a3c",
      "primary-variant": "#006838",
      secondary: "#869097",
      "secondary:hover": "#a8afb4",
      "secondary:10": "#1e2832",
      "secondary-variant": "#203a9a",
      "secondary-variant:hover": "#344fb3",
      "secondary-variant:10": "#cbd4f6"
    },
    background: {
      primary: "#1e2832",
      "primary:lighten": "#2a3540",
      "primary:darken": "#19222b",
      secondary: "#f7f9fa",
      "secondary:lighten": "#ffffff",
      "secondary:darken": "#ebeef0",
      "overlay:90": "rgba(42, 53, 64, 0.9)",
      "overlay:50": "rgba(42, 53, 64, 0.5)",
      "overlay:25": "rgba(42, 53, 64, 0.25)",
      light: "#ffffff",
      dark: "#19222b"
    },
    text: {
      primary: "#ffffff",
      secondary: "#c9d0d6",
      tertiary: "#869097",
      reverse: "#52667a",
      light: "#ffffff",
      dark: "#52667a"
    },
    webtitle: {
      primary: "#ffffff",
      secondary: "#c9d0d6",
      tertiary: "#869097",
      reverse: "#2a3540",
      light: "#ffffff",
      dark: "#52667a"
    },
    action: {
      success: "#7ac542",
      "success:hover": "#90e254",
      "success:10": "#334a3c",
      danger: "#fd6b6b",
      "danger:hover": "#fe9f9f",
      "danger:10": "#483c45",
      warning: "#ffca37",
      "warning:hover": "#ffdc7c",
      "warning:10": "#494936",
      info: "#4eadc0",
      "info:hover": "#60d2e8",
      "info:10": "#2a4753",
      soft: "#52667a",
      "soft:hover": "#869097",
      reverse: "#2a3540",
      "reverse:hover": "#52667a",
      light: "#ffffff",
      "light:hover": "#ebeef0",
      dark: "#52667a",
      "dark:hover": "#2a3540"
    },
    border: {
      primary: "#6a7b87",
      reverse: "#52667a"
    },
    weather: {
      rainfall: "#4eadc0",
      temperature: "#ffca37",
      "temperature-cold": "#cbf0ff",
      hygrometry: "#675fc5",
      wind: "#19222b",
      "wind-gust": "#19222b",
      wetness: "#4eadc0",
      light: "#ffffff",
      dark: "#2a3540"
    },
    social: {
      owner: "#7ac542",
      "owner-variant": "#45920b",
      guest: "#4eadc0",
      "guest-variant": "#2a85a3",
      network: "#ffca37",
      position: "#fd6b6b",
      disable: "#19222b"
    },
    global: {
      green: "#7ac542",
      "green:hover": "#90e254",
      "green:10": "#334a3c",
      red: "#fd6b6b",
      "red:hover": "#fe9f9f",
      "red:10": "#483c45",
      yellow: "#ffca37",
      "yellow:hover": "#ffdc7c",
      "yellow:10": "#494936",
      blue: "#4eadc0",
      "blue:hover": "#60d2e8",
      "blue:10": "#2a4753",
      purple: "#4e45c0",
      "purple:hover": "#6359d6",
      "purple:10": "#242060",
      orange: "#ff9000",
      "orange:hover": "#fca432",
      "orange:10": "#663a00"
    }
  }
}; // name: dark

import flatten, { unflatten } from "flat";
export var THEMES = [LIGHT_THEME, DARK_THEME];
export var addThemeHelpers = function addThemeHelpers(theme) {
  return _objectSpread({}, theme, {
    color: function color(type, name) {
      var _theme$colors, _theme$colors$type;

      return (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : (_theme$colors$type = _theme$colors[type]) === null || _theme$colors$type === void 0 ? void 0 : _theme$colors$type[name];
    }
  });
};
export var mergeTheme = function mergeTheme(baseConfig, newConfig) {
  return unflatten(_objectSpread({}, flatten(baseConfig), {}, flatten(newConfig)), {
    object: true
  });
};
export var DEFAULT_THEME = LIGHT_THEME;